<script>
	import { selectedCarePlan } from '../stores.js';
	import { selectedHostingPlan } from '../stores.js';

    $: mailSubject = encodeURIComponent("Mon pack : " + $selectedHostingPlan.title + ' ' + $selectedCarePlan.title);
    $: mailBodyText = `
Bonjour,

J'ai choisi le pack :\n`
+ $selectedHostingPlan.title + ' ' + $selectedCarePlan.title + ` à ` + ($selectedHostingPlan.title == 'Sur Mesure' ? 'partir de ' : '') + ($selectedCarePlan.price + $selectedHostingPlan.price) +`€ht/mois\n\n` +
`Mes informations de contact :

Prénom : [à remplir]
Nom : [à remplir]
Adresse Email : [à remplir]
Téléphone : [à remplir]

Raison sociale et adresse de facturation :
[à remplir]


J'attends votre retour.
À très vite ;`;
    $: mailBody = encodeURIComponent(mailBodyText.trim());

</script>


<div class="total-wrap">
    <div class="tile hosting">
        <span class="title">Hosting</span>
        <span class="product-title">{$selectedHostingPlan.title}</span>
    </div>
    <div class="sign-wrap">
        <span>+</span>
    </div>
    <div class="tile care-plan">
        <span class="title">Care Plan</span>
        <span class="product-title">{$selectedCarePlan.title}</span>
    </div>
    <div class="sign-wrap">
        <span>=</span>
    </div>
    <div class="tile total">
        <div>
            {#if $selectedHostingPlan.title != 'Sur Mesure'}
                <span class="product-title">{$selectedCarePlan.price + $selectedHostingPlan.price}€</span><br>
            {:else}
            <span class="from">À partir de</span> <span class="product-title">{$selectedCarePlan.price + $selectedHostingPlan.price}€</span><br>
            {/if }
            <span class="price-info">ht/mois</span>
        </div>
        <a target="_blank" href="mailto:lg@laugau.com?subject={mailSubject}&body={mailBody}" class="c-btn">Let's Go!</a>
    </div>
</div>


<style>
    .total-wrap {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        justify-content: center;
    }
    .tile {
        background: #fff;
        padding: 14px 24px;
        box-shadow: 0px 2px 10px hsla(216, 65%, 18%, 0.1);
    }
    .sign-wrap{
        color: #fff;
        line-height: 32px;
        font-size: 22px;
        width: 32px;
        margin: 0 -10px;
        z-index: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .sign-wrap span {
        width: 32px;
        height: 32px;
        background: #10284B;
        border-radius: 50%;
        display: flex;
        flex-direction: column;
    }
    .care-plan, .hosting{
        display: flex;
        flex-direction: column;
        min-width: 150px;
        justify-content: center;
    }

    .title {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        color: #859DB7;
        font-size: 14px;
        margin-bottom: 6px;
    }
    .product-title{
        font-family: Georgia, 'Times New Roman', Times, serif;
        font-weight: bold;
        font-size: 18px;
    } 
    .price-info {
        color: #859DB7;
        font-size: 14px;
    }
    .from {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        color: #859DB7;
        font-size: 14px;
    }
    .total{
        display: flex;
        align-items: center
    }
    .c-btn{
        margin: 0;
        margin-left: 14px;
        background-color: #10284B;
        color: #fff;
        text-transform: uppercase;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        padding: 0.5em 0.8em;
        text-decoration: none;
    }
    @media all and (max-width: 550px) {
        .total-wrap {
            flex-direction: column;
        }
        .sign-wrap {
            margin: -5px auto;
        }
        .total {
            justify-content: center;
        }
    }
</style>